module.exports = __webpack_public_path__ + "static/img/icon-tips.24d938f9.svg";